import React, { useState } from 'react';
import { signInWithGoogle } from '../../lib/cloudflare';
import { useAuthStore } from '../../store/authStore';
import { Loader2 } from 'lucide-react';

interface GoogleSignInProps {
  onSuccess?: () => void;
  onError?: (error: Error) => void;
}

const GoogleSignIn: React.FC<GoogleSignInProps> = ({ onSuccess, onError }) => {
  const [isLoading, setIsLoading] = useState(false);
  const { setUser } = useAuthStore();

  const handleGoogleSignIn = async () => {
    try {
      setIsLoading(true);
      
      const googleUser = await signInWithGoogle();
      
      if (googleUser) {
        // Auth 스토어에 사용자 정보 설정
        setUser(googleUser);
        onSuccess?.();
      }
    } catch (error) {
      console.error('로그인 실패:', error);
      onError?.(error as Error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <button
      onClick={handleGoogleSignIn}
      disabled={isLoading}
      className={`
        w-full bg-white hover:bg-gray-50 
        text-gray-700 font-semibold py-4 px-6 
        border border-gray-300 rounded-2xl
        flex items-center justify-center space-x-3
        transition-all duration-300 ease-out
        shadow-soft hover:shadow-medium
        focus:outline-none focus:ring-4 focus:ring-gray-200
        disabled:opacity-50 disabled:cursor-not-allowed
        min-h-[56px]
        ${isLoading ? 'animate-pulse' : 'hover:scale-[1.02] active:scale-95'}
      `}
    >
      {isLoading ? (
        <Loader2 className="w-5 h-5 animate-spin" />
      ) : (
        <svg className="w-5 h-5" viewBox="0 0 24 24">
          <path
            fill="#4285F4"
            d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
          />
          <path
            fill="#34A853"
            d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
          />
          <path
            fill="#FBBC05"
            d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
          />
          <path
            fill="#EA4335"
            d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
          />
        </svg>
      )}
      
      <span className="text-base">
        {isLoading ? '로그인 중...' : 'Google로 시작하기'}
      </span>
    </button>
  );
};

export default GoogleSignIn; 